(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flipped-header"]) return;
  try {
    
  import('@theme/events').then(({ CartAddEvent, ThemeEvents }) => {
  document.addEventListener(ThemeEvents.cartUpdate, (event) => {
    const cartLink = document.querySelector('.fs-cart');
    if (!cartLink || event.detail?.data?.didError) return;
    const count = event.detail?.resource?.item_count;
    if (typeof count === 'number') cartLink.querySelector('span').textContent = `(${count})`;
    if (event instanceof CartAddEvent) window.location.assign(cartLink.href);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
